import { MatDateFormats } from '@angular/material/core';

/**
 * MatDateFormats used together with `DayjsDateAdapter`.
 *
 * Mirrors the layout of the previous `MAT_MOMENT_DATE_FORMATS` defaults
 * so existing templates keep rendering the same format strings.
 *
 * Token name kept (`MAT_DAYJS_DATE_FORMATS`) for parity with the
 * moment/luxon adapters shipped by Angular Material.
 */
export const MAT_DAYJS_DATE_FORMATS: MatDateFormats = {
    parse: {
        dateInput: ['DD/MM/YYYY', 'DD-MM-YYYY', 'YYYY-MM-DD'],
    },
    display: {
        dateInput: 'DD/MM/YYYY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'DD/MM/YYYY',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};
